<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">学校组织名称：</div>
                        <el-input v-model="schoolName" placeholder="请输入学校组织名称"></el-input>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">地区：</div>
                        <addressSelect ref="addressSearch"></addressSelect>
                    </div>
                </el-col>
                <el-col :span="6" :offset="4">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="search('refresh')">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="whiteBg main-middle">
            <div class="box box-align-center mt-btns">
                <el-button type="primary" plain icon="el-icon-plus" @click="schoolDialogOpen()">新增学校组织</el-button>
                <el-button type="warning" plain icon="el-icon-upload" @click="uploadDialogOpen()">批量导入</el-button>
            </div>
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="schoolList" ref="table"
                v-loading="tableLoading" :total="total" :page-num="pageNum" :page-size="pageSize"
                @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
        </div>

        <el-dialog title="管理员信息" :visible.sync="adminDialog" width="80%" :close-on-click-modal="false">
            <dy-table :columns="adminColumns" style="margin-top: 12px;" :table-data="adminList" ref="table"
                v-loading="adminLoading" :total="adminTotal" :page-num="adminPage" :page-size="adminSize"
                @current-change="adminPageChange" element-loading-text="加载中"></dy-table>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <!-- <el-button type="primary" plain @click="infoSave()">保存</el-button> -->
                <el-button type="danger" plain @click="() => adminDialog = false">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog title="学校/组织信息" :visible.sync="schoolDialog" width="80%" :close-on-click-modal="false">
            <el-form ref="schoolForm" v-if="schoolDialog" label-position="right" label-width="60px" :model="school"
                :rules="schoolRules">
                <el-form-item label="学校/组织名称：" prop="schoolName" required>
                    <el-input style="width: 500px;" v-model="school.schoolName" placeholder="请输入学校/组织名称"></el-input>
                </el-form-item>
                <el-form-item label="地址：" required>
                    <!-- <el-input style="width: 500px;" v-model="school.local" placeholder="请选择地址"></el-input> -->
                    <addressSelect ref="schoolAddress" :address="schoolAddress"></addressSelect>
                </el-form-item>
            </el-form>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <el-button type="primary" plain @click="schoolSave()">保存</el-button>
                <el-button type="danger" plain @click="() => schoolDialog = false">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog v-loading="uploadLoading" title="批量导入" :visible.sync="uploadDialog" width="80%" :close-on-click-modal="false">
            <div class="flex jc-c">
                <el-upload ref="upload" action="/dummy" :on-change="fileChange" :on-remove="fileRemove"
                    :on-exceed="fileExceed" :limit="1" :auto-upload="false" drag>
                    <div>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </div>
                </el-upload>
            </div>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <el-button type="primary" plain icon="el-icon-download" @click="downloadFile">下载模版</el-button>
                <el-button type="primary" plain @click="uploadSave()">保存</el-button>
                <el-button type="danger" plain @click="() => uploadDialog = false">取消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="合并学校/组织" :visible.sync="mergeDialog" width="80%" :close-on-click-modal="false">
            <!-- <el-form ref="schoolForm" v-if="schoolDialog" label-position="right" label-width="60px">
                <el-form-item label="待合并学校组织：" required> -->

            <div class="flex jc-fs ai-fs" style="min-height: 150px;">
                <div style="margin-right: 20px; margin-top: 5px;">
                    待合并学校组织：
                </div>
                <el-select v-model="mergeList" multiple filterable remote reserve-keyword placeholder="下拉支持多选，搜索"
                    :remote-method="remoteMethod">
                    <el-option v-for="item in mergeOpt" :key="item.schoolId" :label="item.schoolName"
                        :value="item.schoolId">
                    </el-option>
                </el-select>
            </div>
            <!-- </el-form-item>
            </el-form> -->
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <el-button type="primary" plain @click="mergeSave()">保存</el-button>
                <el-button type="danger" plain @click="() => mergeDialog = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from "axios";
import DyTable from '@/components/common/dytable'
import XLSX from 'xlsx';
import MultiExportFiles from '@/components/common/multiExportFiles'

import addressSelect from '../components/addressSelect'


import { queryLog } from '@/api/index';
import { formatDate, formatJson } from '@/utils/utils';
import { encrypt, decrypt } from '@/api/common_encrypt';



import { getSchoolList, updateSchoolFlg, getSchoolAdmin, deleteSchoolAdmin, addSchool, editSchool, mergeSchool } from '@/api/index';


export default {
    data() {
        return {

            school: {},
            schoolAddress: [],
            tableLoading: false,
            columns: [],
            schoolList: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,


            adminDialog: false,
            adminLoading: false,
            adminColumns: [],
            adminList: [],
            adminTotal: 0,
            adminPage: 1,
            adminSize: 10,


            schoolName: '',
            exportVisible: false,
            rangeDate: 3,

            filename: '操作日志',


            schoolDialog: false,
            schoolRules: {
                schoolName: [
                    { required: true, message: '请输入学校/组织名称', trigger: 'blur' },
                    { required: true, message: '请输入学校/组织名称', trigger: 'change' },
                ],

                local: [
                    { required: true, message: '请选择地址', trigger: 'blur' },
                    { required: true, message: '请选择地址', trigger: 'change' },
                ],
            },


            uploadDialog: false,
            uploadLoading: false,


            limitUpload: 1,
            uploadList: [],

            mergeDialog: false,
            mergeName: "",
            mergeOpt: [],
            mergeList: [],


            searchForm: {},
        }
    },
    components: {
        DyTable,
        MultiExportFiles,
        addressSelect
    },
    created() {
        this.columns = [
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'schoolName',
                title: '学校/组织名称'
            },
            {
                title: '地区',
                render: ({ row }) => {
                    return (
                        <div>{`${row.province}/${row.city}/${row.country}`}</div>
                    );
                },
            },
            {
                key: 'bgUserName',
                title: '操作人'
            },
            {
                key: 'createTime',
                title: '创建时间'
            },
            {
                key: 'schoolStatus',
                title: '状态',
                render: ({ row }) => {
                    return (
                        <div>
                            {row.schoolStatus == 0 && (
                                <el-button type="danger" round size="mini">未启用</el-button>

                            )}
                            {row.schoolStatus == 1 && (
                                <el-button type="primary" round size="mini">已启用</el-button>
                            )}
                        </div>
                    );
                },
            },
            {
                title: '操作',
                width: 300,
                render: ({ row }) => {
                    return (
                        <div>
                            {row.schoolStatus == 0 && (
                                <el-link type="primary" style="margin-left:12px" onClick={() => this.schoolDialogOpen(row)}>编辑</el-link>
                            )}
                            <el-link type="primary" style="margin-left:12px" onClick={() => this.updateSchoolFlg(row)}>
                                {row.schoolStatus == 0 && ('启用')}
                                {row.schoolStatus == 1 && ('禁用')}
                            </el-link>
                            {row.schoolStatus == 0 && (
                                <el-link type="primary" style="margin-left:12px" onClick={() => this.mergeDialogOpen(row)}>合并</el-link>
                            )}
                            <el-link type="primary" style="margin-left:12px" onClick={() => this.adminDialogOpen(row)}>查看管理员</el-link>
                        </div>
                    );
                },
            },
        ];


        this.adminColumns = [

            {
                key: 'idName',
                title: '管理员姓名'
            },
            {
                key: 'idNo',
                title: '管理员身份证号'
            },
            {
                key: 'createTime',
                title: '成为管理员时间'
            },
            {
                title: '操作',
                width: 100,
                render: ({ row }) => {
                    return (
                        <el-link type="danger" style="margin-left:12px" onClick={() => this.adminDel(row)}>移除</el-link>
                    );
                },
            },
        ];
    },
    mounted() {
        this.getList();
    },
    methods: {
        logDragEvent(event) {
            console.log('File dragging over:', event);
        },

        // 导出
        handleCommand(type) {
            let tHeader = ['功能模块', '功能子模块', '操作类型', '账号', '用户名', '操作时间', '用户IP'];

            let tValue = ['modelName', 'subModelName', 'operateName', 'userAccount', 'userName', 'createTime', 'userIp'];
            var query = {
                userName: '',
                rangeDate: type,
                needPage: false,
            };
            const queryData = encrypt(JSON.stringify(query))
            queryLog(queryData).then(resp => {
                var data = JSON.parse(decrypt(resp.data.replace(/[\r\n]/g, '')));
                this.levelList = data;
                import('@/components/ExportExcel/Export2Excel').then(excel => {
                    const data = formatJson(tValue, this.levelList);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.filename,
                        autoWidth: true,
                        bookType: 'xlsx'
                    });
                });
            }, () => {
                this.isloading = false
            })
        },

        search(msg) {
            let address = this.$refs.addressSearch.getAddress();
            for (let a in address) {
                console.log('a :>> ', a);
                this.searchForm[a] = address[a].val || null;
            }
            this.searchForm.schoolName = this.schoolName;
            if (msg == 'refresh') {
                this.schoolName = '';
                this.schoolAddress = []
                this.pageNum = 1;
                this.searchForm = {};
            }
            this.getList();
        },

        onCurrentChange(val) {
            this.pageNum = val
            this.getList()
        },

        //操作日志列表
        getList() {
            let info = {
                needPage: true,
                page: this.pageNum,
                pageSize: this.pageSize,
                ...this.searchForm
            };
            console.log('getList', info);
            this.tableLoading = true;
            var data = encrypt(JSON.stringify(info));
            getSchoolList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    this.total = ress.total;
                    this.schoolList = ress.list;
                    console.log('schoolList :>> ', this.schoolList);
                    this.tableLoading = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },

        updateSchoolFlg(row) {
            console.log('row :>> ', row);
            let info = {
                schoolId: row.schoolId,
                schoolStatus: row.schoolStatus == 0 ? 1 : 0,
            };

            this.tableLoading = true;
            var data = encrypt(JSON.stringify(info));
            updateSchoolFlg(data).then((res) => {
                if (res.result == 1) {
                    this.tableLoading = false;
                    this.getList()
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },

        adminDialogOpen(row) {
            this.school = row;
            this.adminPage = 1;
            this.getAdmin();
            this.adminDialog = true;
        },

        adminDel(row) {
            deleteSchoolAdmin
            let info = {
                id: row.id,
                schoolId: this.school.schoolId,
                userId: row.userId,
            };

            this.adminLoading = true;
            var data = encrypt(JSON.stringify(info));
            deleteSchoolAdmin(data).then((res) => {
                if (res.result == 1) {

                    this.adminLoading = false;
                    this.getAdmin()
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        adminPageChange() {
            this.adminPage = val
            this.getAdmin()
        },

        getAdmin() {
            let info = {
                needPage: true,
                page: this.pageNum,
                pageSize: this.pageSize,
                schoolId: this.school.schoolId,
            };

            this.adminLoading = true;
            var data = encrypt(JSON.stringify(info));
            getSchoolAdmin(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));

                    this.adminTotal = ress.total;
                    this.adminList = ress.list;
                    this.adminLoading = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },

        schoolDialogOpen(row = {}) {
            this.school = { ...row };
            let arr = []
            if (row && row.schoolId) {
                arr = [row.provinceCode, row.cityCode, row.countryCode]
            }
            this.schoolAddress = [...arr];
            this.schoolDialog = true;
        },

        schoolSave() {
            let address = this.$refs.schoolAddress.getAddress();
            this.$refs.schoolForm.validate((valid) => {
                if (valid) {
                    let info = {
                        list: [
                            {
                                ...this.school,
                                province: this.school.schoolId ? address.province.val : address.province.text,
                                city: this.school.schoolId ? address.city.val : address.city.text,
                                country: this.school.schoolId ? address.country.val : address.country.text,
                                // schoolName: this.school.schoolName,
                                // schoolId: this.school.schoolId
                            }
                        ]
                    };

                    if (!info.list[0].country) {
                        this.$message({
                            type: 'warning',
                            message: '请选择完整地址！'
                        });
                        return
                    }

                    if (this.school.schoolId) {

                        editSchool(encrypt(JSON.stringify(info.list[0]))).then((res) => {
                            this.$message({
                                showClose: true,
                                message: "编辑成功",
                                type: 'success'
                            });
                            this.getList()
                        });
                    } else {
                        addSchool(encrypt(JSON.stringify(info))).then((res) => {
                            this.$message({
                                showClose: true,
                                message: "添加成功",
                                type: 'success'
                            });
                            this.getList()
                        });
                    }

                    this.schoolDialog = false;

                } else {
                    return false;
                }
            });
        },


        uploadDialogOpen() {
            this.uploadList = [];
            this.uploadDialog = true;
        },

        downloadFile() {
            // 服务器文件的 URL
            const fileUrl = "https://zhigu.obs.cn-north-4.myhuaweicloud.com/img/2025/12/31/img_1735608481530.xls";
            const fileName = "学校认证模板.xls";

            // 创建下载链接
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = fileName;
            link.target = "_blank";
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        },

        // async downloadFile() {
        //     const fileUrl = "https://zhigu.obs.cn-north-4.myhuaweicloud.com/img/2025/12/31/img_1735608481530.xls";
        //     const fileName = "学校认证模板.xls";
        //     try {
        //         const response = await axios.get(fileUrl, {
        //             responseType: "blob", // 确保接收的是文件流
        //         });
        //         const blob = new Blob([response.data], { type: response.headers["content-type"] });
        //         const link = document.createElement("a");
        //         link.href = URL.createObjectURL(blob);
        //         link.download = fileName; // 指定文件名
        //         link.style.display = "none";
        //         document.body.appendChild(link);
        //         link.click();
        //         URL.revokeObjectURL(link.href);
        //         document.body.removeChild(link);
        //     } catch (error) {
        //         console.error("文件下载失败：", error);
        //     }
        // },

        fileRemove() { },
        fileExceed() { },
        fileChange(file, fileList) {
            this.fileTemp = file.raw;
            if (this.fileTemp) {
                if ((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                    (this.fileTemp.type == 'application/vnd.ms-excel')) {
                    this.handleExcel(this.fileTemp);
                } else {
                    this.$refs.upload.clearFiles();
                    this.$message({
                        type: 'warning',
                        message: '文件格式错误，请重新上传！'
                    });
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '请上文件！'
                });
            }
        },
        handleExcel(fileTemp) {
            let _this = this;
            this.file = fileTemp;
            var reader = new FileReader();
            reader.onload = function (e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: 'array' });
                var firstSheetName = workbook.SheetNames[0];
                var worksheet = workbook.Sheets[firstSheetName];
                var jsonData = XLSX.utils.sheet_to_json(worksheet);
                _this.uploadList = jsonData;
            };
            reader.readAsArrayBuffer(fileTemp);
        },

        uploadSave() {
            if (!this.uploadList.length) {
                this.$message({
                    type: 'warning',
                    message: '请上文件！'
                });
                return
            }
            this.uploadLoading = true;
            let info = {
                list: []
            };
            for (let f of this.uploadList.slice(2)) {
                info.list.push({
                    schoolName: f["组织/学校信息模板"],
                    province: f.__EMPTY,
                    city: f.__EMPTY_1,
                    country: f.__EMPTY_2

                })
            }
            addSchool(encrypt(JSON.stringify(info))).then((res) => {
                this.$message({
                    showClose: true,
                    message: "添加成功",
                    type: 'success'
                });
                this.uploadLoading = false;
                this.getList()
                this.uploadDialog = false
            });
        },

        mergeDialogOpen(row) {
            this.school = row;
            this.mergeDialog = true;
        },

        mergeSave() {
            let info = {
                schoolId: this.school.schoolId,
                list: [],
            }
            mergeSchool(encrypt(JSON.stringify(info))).then((res) => {
                this.$message({
                    showClose: true,
                    message: "编辑成功",
                    type: 'success'
                });
                this.getList()
            });
        },

        remoteMethod(query) {
            if (query !== '') {

                let info = {
                    needPage: false,
                    schoolName: query,
                };
                console.log(info);
                getSchoolList(encrypt(JSON.stringify(info))).then((res) => {
                    if (res.result == 1) {
                        var ress = JSON.parse(decrypt(res.data));
                        this.mergeOpt = ress;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });

            } else {
                this.mergeOpt = [];
            }
        },

    }
}
</script>
<style lang="scss" scoped>
/deep/.el-form-item__content {
    width: 50%;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    display: flex;
    white-space: nowrap;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>